import type {
  PluginFooter,
  PluginFooterMode,
} from '@sportninja/common/features/account/apiAccess'

/** Which footer choice a stored footer is: unset, hidden, or the league's own. */
export const pluginFooterModeOf = (
  footer: PluginFooter | null
): PluginFooterMode =>
  footer === null ? 'sportninja' : footer === 'hidden' ? 'hidden' : 'custom'
